function filterModule () {

	__ = null
	route = null

	this.setRoute = function (route) {
		this.route = route
	}

	this.addToData = function ($element, data) {
		var filter_name_attr = $element.attr('name')
		if (typeof filter_name_attr === "undefined") {
			return data
		}

		is_array = (filter_name_attr.indexOf('[]') > -1)
		if (is_array) {
			if (typeof data[filter_name_attr] === "undefined") {
				data[filter_name_attr] = []
			}
			data[filter_name_attr].push($element.val())
		} else {
			data[filter_name_attr] = $element.val()
		}

		return data
	}

	this.build = function () {

		var _this = this;

		var data = {
			_token: $('meta[name="csrf-token"]').attr('content')
		}

		$('.js-filter-item').each(function () {
			var $this = $(this)
			var filter_name_attr = $this.attr('name')

			if ($this.is(':checkbox')) {
				if ($this.prop('checked')) {
					data = _this.addToData($this, data)
				}
			} else if ($this.is('select')) {
				data[$this.attr('name')] = $this.val()
			} else {
				data = _this.addToData($this, data)
			}
		})
		return data
	}

	this.changeListener = function (change_selector) {

		var __ = this

		$(change_selector).on('change', function () {
			var $this = $(this)
			if ($this.is(':checkbox')) {
				if (typeof $this.attr('data-radio-filter') !== "undefined") {
					if ($this.prop('checked')) {
						// Checked
						var radio_group = $this.attr('data-radio-filter');
						$('[data-radio-filter="'+ radio_group +'"]').prop('checked', false)
						$this.prop('checked', true)
					} else {
						// Unchecked
						console.log('unchecked')
					}
				}
			}
			__.submit()
		})
	}

	this.submit = function () {
		data = this.build()
		var form = $('<form></form>');
        form.attr("method", "post");
        form.attr("action", this.route);
        $.each(data, function( key, value ) {
            var field = $('<input></input>');
            field.attr("type", "hidden");
            field.attr("name", key);
            field.attr("value", value);
            form.append(field);
        });

        $(form).appendTo('body').submit();
	}
}

module.exports = filterModule